export const CAMPAIGNPAGE_LOADING = "CAMPAIGNPAGE_LOADING";
export const GET_DEPTSTRUCTURE = "GET_DEPTSTRUCTURE";
export const CAMPAIGNPAGE_RESET = "CAMPAIGNPAGE_RESET";
export const GET_STRUCURE = "GET_CAMPAIGNPAGE";
export const GET_CAMPAIGNPAGE = "GET_CAMPAIGNPAGE";
export const GET_CAMPAIGNPAGE_SUCCESS = "GET_CAMPAIGNPAGE_SUCCESS";
export const GET_CAMPAIGNPAGE_FAIL = "GET_CAMPAIGNPAGE_FAIL";
export const DELETE_CAMPAIGNPAGE = "DELETE_CAMPAIGNPAGE"
export const DELETE_CAMPAIGNPAGE_SUCCESS = "DELETE_CAMPAIGNPAGE_SUCCESS"
export const DELETE_CAMPAIGNPAGE_FAIL = "DELETE_CAMPAIGNPAGE_FAIL"
export const UPDATE_CAMPAIGNPAGE = "UPDATE_CAMPAIGNPAGE"
export const UPDATE_CAMPAIGNPAGE_SUCCESS = "UPDATE_CAMPAIGNPAGE_SUCCESS"
export const UPDATE_CAMPAIGNPAGE_FAIL = "UPDATE_CAMPAIGNPAGE_FAIL"
export const ADD_NEW_CAMPAIGNPAGE = "ADD_NEW_CAMPAIGNPAGE"
export const ADD_CAMPAIGNPAGE_SUCCESS = "ADD_CAMPAIGNPAGE_SUCCESS"
export const ADD_CAMPAIGNPAGE_FAIL = "ADD_CAMPAIGNPAGE_FAIL"